import { render } from "./Expense.vue?vue&type=template&id=6141329c&scoped=true"
import script from "./Expense.vue?vue&type=script&lang=js"
export * from "./Expense.vue?vue&type=script&lang=js"

import "./Expense.vue?vue&type=style&index=0&id=6141329c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-6141329c"

export default script